import { render, staticRenderFns } from "./Task2.vue?vue&type=template&id=0ebcfa64&scoped=true&"
import script from "./Task2.vue?vue&type=script&lang=js&"
export * from "./Task2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebcfa64",
  null
  
)

export default component.exports